<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    customHeight="h-136"
    customWidth="lg:w-160"
  >
    <template #modal-header>
      <div class="">
        <div class="flex items-center">
          <Icon name="Pencil" class="w-4 h-4 mr-1 stroke-info" />
          <div class="text-sm font-inter font-semibold text-info">Editing</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          Edit Document
        </div>
      </div>
    </template>

    <template #modal-body>
      <div class="p-4 grid grid-cols-2 gap-4">
        <div class="col-span-2">
          <BaseInput
            v-model="modal_config.record.file_category"
            label="File Category"
            field_type="dropdown"
            variant="secondary"
            :dropdown_options="modal_config.file_category_options"
          />
        </div>
        <div class="col-span-2">
          <BaseInput
            v-model="modal_config.record.file_name"
            label="File Name"
            field_type="string"
            variant="secondary"
            :read_only="true"
          />
        </div>
        <div class="col-span-1">
          <BaseInput
            v-model="modal_config.record.created_date"
            label="Created Date"
            field_type="date"
            variant="secondary"
            :read_only="true"
          />
        </div>
        <div class="col-span-1">
          <BaseInput
            v-model="modal_config.record.file_type"
            label="File Type"
            field_type="string"
            variant="secondary"
            :read_only="true"
          />
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleConfirm()" variant="primary-grey" size="sm" class="">
          <template #label>Confirm</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
// IMPORTS
import { Modal, Icon, Button, BaseInput } from "@/components";
import { useCrudStore, useUIStore, useSchemaStore } from "@/stores";

//STORES
const crudStore = useCrudStore();
const UIStore = useUIStore();
const schemaStore = useSchemaStore();

//EMITS AND PROPS
const emit = defineEmits(["close-modal", "refresh"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

// COMPONENT LOGIC AND FUNCTIONS
async function handleConfirm() {
  try {
    if (props.modal_config.record.file_category === props.modal_config.og_record.file_category) {
      emit("close-modal");
      return;
    }

    let query = [
      {
        field_name: "record_id",
        operator: "eq",
        value: props.modal_config.record.record_id,
      },
    ];

    let update = {
      file_category: props.modal_config.record.file_category,
    };

    update = schemaStore.addCreatedUpdatedFields(update, false, true);

    let update_res = await crudStore.update("documents", query, update);

    if (update_res.status !== 200) {
      throw new Error("Failed to update document");
    }

    emit("refresh");
    emit("close-modal");
  } catch (error) {
    var alert = {
      type: "error",
      message: `Failed to update document.`,
    };
    UIStore.animateNotificationAlert(alert);
    emit("close-modal");
  }
}
</script>
